import React from 'react'
import { Card } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

export interface CarousalCardProps {
  images: { src: string }[]
}
const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
}

const useStyles = makeStyles((theme: any) => ({
  carousal: {
    height: '200px',
    '& .react-multiple-carousel__arrow': {
      width: '58px',
      height: '58px',
      backgroundColor: theme.palette.common.white,
      background: 'none',
      opacity: 'none',
      right: '-24px',
    },
    '& ::before': {
      color: 'black',
    },
    '& .react-multiple-carousel__arrow--left': {
      left: '-25px',
    },
  },

  styledImage: {
    width: '100%!important',
  },
}))
const CarousalCard = ({ images }: CarousalCardProps) => {
  const classes = useStyles()
  return (
    <Carousel
      responsive={responsive}
      ssr={true}
      infinite={true}
      autoPlaySpeed={1000}
      keyBoardControl={true}
      customTransition="all .5"
      transitionDuration={500}
      containerClass="carousel-container"
      className={classes.carousal}
    >
      {images.map((img, index) => {
        return (
          <Card key={index}>
            <img src={img.src} width="100%" alt="" />
          </Card>
        )
      })}
    </Carousel>
  )
}
export default CarousalCard
